import client from "./client";

export const getResourcePage = () => client.post("/resourcepage/getPage");
export const addResourcePage = (payload) =>
  client.post("/resourcepage/addpage", payload);
export const updateResourcePage = (payload) =>
  client.post("/resourcepage/updatePage", payload);
